import React, {Fragment} from 'react'
import filterStyles from '../filters.scss'
import styles from './SetPrivacyMenu.scss'
import {OrderedMap} from 'immutable'
import {RadioGroup} from 'common/styleguide/RadioGroup'

export class SetPrivacyMenu extends React.PureComponent {
  state = {
    selected: null
  }

  render () {
    const {onApply} = this.props
    const {selected} = this.state

    return (
      <Fragment>
        <RadioGroup
          options={OrderedMap({
            '0': 'Public',
            '1': 'Private',
            '2': 'Friends Only'
          })}
          selected={selected}
          onChange={(value) => this.setState({selected: value})}
          radioClass={styles.radioClass}
          horizontal={false}
        />
        <a className={filterStyles.apply} onClick={() => onApply(selected)}>Set Privacy</a>
      </Fragment>
    )
  }
}
